import CommonRegex from 'constants/CommonRegex';
import { getSystemMessage } from 'store/system/systemMessageReducer';
import { getStore } from 'store';

export const checkIsChineseInput = (value = '') => {
    const re = new RegExp(CommonRegex.REGEX_CHINESE);
    return re.test(value);
};

export const checkIsContainsAlphabet = (value = '') => {
    const re = new RegExp(CommonRegex.REGEX_ALPHABET);
    return re.test(value);
};

export const checkIsDomain = (value) => {
    const re = new RegExp(CommonRegex.REGEX_DOMAIN);
    return re.test(String(value).toLowerCase());
};

export const checkValueLength = (value, minLength, maxLength) => {
    let tempError = [];
    if (minLength && value?.length < minLength) {
        tempError.push(getSystemMessage('lessLength', [minLength]));
    }
    if (maxLength && value?.length > maxLength) {
        tempError.push(getSystemMessage('longerLength', [maxLength]));
    }
    return tempError;
};

export const checkIsAuthorizedEmail = (value) => {
    const { emailDomain } = getStore().getState();
    const emailDomainList = emailDomain.emailDomainList;
    const isAuthorizedEmail = emailDomainList.some((item) => {
        let email = item.email;
        const index = email.indexOf('*');
        if (index !== -1) {
            email = email.slice(index + 1);
        }
        return value?.toLowerCase().includes(email.toLowerCase()) && item.enable;
    });

    return isAuthorizedEmail;
};

export const checkIsFormattedHospital = (hosp) => {
    const { system } = getStore().getState();
    const formattedHospitalData = system.formattedHospitalData;

    const index = formattedHospitalData.findIndex((item) => {
        return item.hospitalName === hosp || item.hospitalCode === hosp;
    });

    return index !== -1;
};
